function shuffle(items) {
    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }
    return shuffled;
}

export default function shuffleQuiz(quiz) {
    return {
        ...quiz,
        questions: shuffle(quiz.questions).map((question) => ({
            ...question,
            Options: shuffle(question.Options)
        }))
    };
}
